module.exports = __webpack_public_path__ + "media/media/about/mike-megh-389bf23242876c2b08ab1130d5459cce.jpg";